import React from 'react';
import { Star, Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Section, CountdownTimer, CTAButton } from './Shared';
export function MidCTA() {
  return <Section className="bg-brand-surface/20 rounded-3xl my-12" data-id="element-219">
      <div className="text-center mb-10" data-id="element-220">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-gold mb-6" data-id="element-221">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <CountdownTimer data-id="element-222" />
      </div>

      <div className="max-w-md mx-auto mb-12" data-id="element-223"></div>

      <h3 className="text-3xl font-serif font-bold text-center mb-10" data-id="element-224">
        ELEGÍ TU COLECCIÓN
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-225">
        {/* Basic Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-gold/15 hover:border-brand-gold/30 transition-colors" data-id="element-226">
          <div className="mb-6" data-id="element-227">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center" data-id="element-228">
              🌿 COLECCIÓN MAESTRA
            </h4>
            <p className="text-brand-gold font-medium" data-id="element-229">3 Tomos + 2 Bonos</p>
          </div>

          <div className="bg-brand-surfaceLight/50 p-4 rounded-xl mb-6 text-sm text-brand-text/80" data-id="element-230">
            <span className="font-bold text-brand-gold" data-id="element-231">Ideal para:</span> Todo
            el sistema de diagnóstico, limpieza y blindaje permanente.
          </div>

          <div className="mb-8" data-id="element-232">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-233">
              $45.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-234">
              $19.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-235">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-236">
            <CTAButton fullWidth className="text-base py-4 bg-brand-surfaceLight text-brand-text border border-brand-gold/30 hover:bg-brand-surfaceLight/80" href="https://www.lumenakasha.com/cart/46669999571133:1" data-id="element-237">
              → QUIERO LA COLECCIÓN MAESTRA
            </CTAButton>
          </div>
        </div>

        {/* Premium Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-gold relative transform lg:-translate-y-4 shadow-[0_0_40px_rgba(196,148,61,0.15)]" data-id="element-238">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-dark font-bold px-4 py-1 rounded-full text-sm flex items-center shadow-lg" data-id="element-239">
            <Star className="w-4 h-4 mr-1 fill-current" data-id="element-240" /> MÁS ELEGIDO
          </div>

          <div className="mb-6 mt-2" data-id="element-241">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center text-brand-text" data-id="element-242">
              🔮 COLECCIÓN COMPLETA ⭐
            </h4>
            <p className="text-brand-gold/80 font-medium" data-id="element-243">
              3 Tomos + 2 Bonos + El Oráculo del Hogar
            </p>
          </div>

          <div className="bg-brand-gold/10 p-4 rounded-xl mb-6 text-sm text-brand-text/90 border border-brand-gold/20" data-id="element-244">
            <span className="font-bold text-brand-gold" data-id="element-245">Incluye además:</span>{' '}
            péndulo, geopatías, geometría sagrada y Ritual del Oro de 7 días.
          </div>

          <div className="mb-8" data-id="element-246">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-247">
              $65.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-248">
              $29.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-249">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-250">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46670000423101:1" data-id="element-251">
              → QUIERO LA COLECCIÓN COMPLETA
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 mt-12 text-sm text-brand-muted flex-row items-start justify-center" data-id="element-252">
        <div className="flex items-center" data-id="element-253">
          <Lock className="w-4 h-4 mr-2" data-id="element-254" /> Pago 100% seguro
        </div>
        <div className="flex items-center" data-id="element-255">
          <Zap className="w-4 h-4 mr-2" data-id="element-256" /> Acceso en 5 minutos
        </div>
        <div className="flex items-center" data-id="element-257">
          <Shield className="w-4 h-4 mr-2" data-id="element-258" /> Garantía 7 días
        </div>
        <div className="flex items-center" data-id="element-259">
          <CreditCard className="w-4 h-4 mr-2" data-id="element-260" /> Mercado Pago · Tarjeta ·
          Transferencia
        </div>
      </div>
    </Section>;
}